import styled from 'styled-components';
import { MenuItem } from '../Menu';
export var ActionMenuItem = styled(MenuItem).withConfig({
  displayName: "styled__ActionMenuItem",
  componentId: "sc-1yopm0o-0"
})(["box-sizing:border-box;"]);